import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=4014f0b9"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports